<div resizeObserver (resizeEvent)="onHeaderResize($event)" role="main">
  @if (allowUpload) {
    <upload #upload [folderPath]="folderPath" (addFile)="addFile($event)" (queueLengthChange)="uploadQueueLength = $event"></upload>
  }
  <div [shown]="filesDetails.apiError" class="madero-style alert alert-danger text-center" role="alert">
    <p><strong>Failed to load files</strong></p>
    {{filesDetails.apiError}}. If the problem persists, please
    <a class="madero-link" href="#" (click)="helpWidgetFactory.showContactUs()">Contact Us</a>.
  </div>
  <div class="tw-flex tw-flex-col md:!tw-flex-row tw-pb-8 tw-px-6 tw-gap-5 tw-items-center">
    <search-filter
      #searchFilter
      class="w-100"
      [filterConfig]="filterConfig"
      [search]="search"
      [doSearch]="search.doSearch"
      [localSearch]="true"
      [focus]="true"
    />
    @if (allowUpload) {
      <div class="search-buttons tw-gap-4" [ngClass]="{'disabled': isTrashFolder}">
        <button type="button" class="tw-min-w-64" tabindex="0" id="newFolderButton" mat-stroked-button (click)="addFolder()" [disabled]="isTrashFolder">
          <mat-icon svgIcon="add-folder" /> Create Folder
        </button>
        <button type="button" class="tw-min-w-64" tabindex="0" mat-stroked-button id="uploadFolderButtonUnsubscribed" (click)="currentPlanService.showUnlockThisFeatureModal()" [hidden]="currentPlanService.isPlanActive()">
          <mat-icon svgIcon="upload" /> Upload Folder
        </button>
        <button type="button" class="tw-min-w-64" tabindex="0" mat-stroked-button id="uploadFolderButton" (click)="uploadComponent?.openFolderSelector()" [shown]="currentPlanService.isPlanActive()">
          <mat-icon svgIcon="upload" /> Upload Folder
        </button>
        <button type="button" class="tw-min-w-64" tabindex="0" id="uploadButtonUnsubscribed" mat-flat-button color="primary" (click)="currentPlanService.showUnlockThisFeatureModal()" [hidden]="currentPlanService.isPlanActive()">
          <mat-icon svgIcon="upload" /> Upload Files
        </button>
        <button type="button" class="tw-min-w-64" tabindex="0" id="uploadButton"  mat-flat-button color="primary" (click)="uploadComponent?.openFileSelector()" [shown]="currentPlanService.isPlanActive()">
          <mat-icon svgIcon="upload" /> Upload Files
        </button>
      </div>
    }
  </div>
  <mat-divider class="light" />
  <div class="tw-flex tw-flex-row tw-p-6 tw-min-w-0 tw-max-w-full" [shown]="isFileListVisible()">
    <div class="flex-row-entry flex-grow tw-flex tw-items-center tw-min-w-0 tw-overflow-hidden">
      <folder-path [folderPath]="folderPath" (folderClicked)="changeFolder({name: $event})"></folder-path>
    </div>
    @if (storageService.isMultipleSelector() && !allowBatchOperations && filesDetails.checkedItemsCount > 0) {
      <div class="flex-row-entry pr-4">
        {{ filesDetails.checkedItemsCount }} Selected
      </div>
    }
    <div class="flex-row-entry" [shown]="filesDetails.bucketExists && allowUpload">
      <list-grid-toggle [(isListView)]="isListView" (isListViewChange)="isListViewChange.emit($event)"></list-grid-toggle>
    </div>
  </div>
  <div [shown]="files.apiError && filesDetails.checkedItemsCount > 0" class="madero-style alert alert-danger text-center tw-mt-8" role="alert">
    <p><strong>{{files.errorMessage}}</strong><br>{{files.apiError}}</p>
  </div>
  <div id="files-toolbar" class="flex-row" [hidden]="fileListStatus.code === 404">
    @if (allowBatchOperations) {
      <batch-operations class="w-100" [listObject]="files"></batch-operations>
    }
  </div>
</div>
<mat-divider class="light" />
<div class="tw-px-3.5" #filesListContainer rvSpinner="storage-selector-loader" [rvShowSpinner]="files.loadingItems">
  @if (isListView) {
    <cdk-virtual-scroll-viewport [itemSize]="68" class="scrollable-list tw-pb-6 horizontal-scroll grid-selector">
      <storage-list-view
        [files]="files.items.list"
        [folderPath]="folderPath"
        [filesDetails]="filesDetails"
        [listOperations]="files.batchOperations?.operations"
        [fileListVisible]="isFileListVisible()"
        [search]="search"
        [selectAll]="files.search.selectAll"
        (selectAllCheckboxes)="files.selectAll()"
        (fileClick)="fileClick($event)"
        (fileSelect)="onFileSelect($event)"
        (operationClick)="handleOperationClick($event)">
      </storage-list-view>
    </cdk-virtual-scroll-viewport>
  }
  @else {
    <div class="tw-py-6 horizontal-scroll grid-selector">
      <storage-grid-view
        #storageGridView
        [files]="files.items.list"
        [folderPath]="folderPath"
        [filesDetails]="filesDetails"
        [fileListVisible]="isFileListVisible()"
        [search]="search"
        [isEmpty]="!files.loadingItems && isEmptyState()"
        [listOperations]="files.batchOperations?.operations"
        (fileClick)="fileClick($event)"
        (fileSelect)="onFileSelect($event)"
        (uploadFiles)="uploadComponent.openFileSelector()">
      </storage-grid-view>
    </div>
  }
</div>